import React from 'react';
import {BrowserRouter as Router, Switch, Route, Redirect} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Preload from "./components/preload/";
import Board from "./components/board/";
import Footer from "./components/footer/";
import { PublicKey } from '@solana/web3.js'
import {
	relayAddress
} from "./helpers/base_config";

function App() {
	
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const sponsor = urlParams.get('sponsor');

	if(sponsor !== null){
		try {
			let address = new PublicKey(sponsor);
			localStorage.setItem("sponsor", sponsor);
		} catch (e) {	
			localStorage.setItem("sponsor", relayAddress);
		}
	}
	
	return (
		<div id="layout-wrapper">
			<React.Suspense fallback={<span>Loading...</span>}>
				<Router>
					<Preload />
					<div className="vertical-overlay"></div>
					<Switch>
						<Route exact path='/'>
							<Board />
						</Route>
						
						<Route path="/:notfound">
							<Redirect to='/'  />
						</Route>
					</Switch>
					<Footer />
				</Router>
			</React.Suspense>
			<ToastContainer />
		</div>
	);
}

export default App;
